<div>
    <div class="sub-header">
        Whatsapp PlayGround...
    </div>

    <div class="row">
        <div class="col-md-3 label">
            Select message template to use
        </div>
        <div class="col-md-3">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><i class="fa fa-user"></i></span>
                <p-dropdown [options]="messageTemplates" [(ngModel)]="selectedMessageTemplate">
                    <ng-template let-template pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            {{template.name}} {{template.language}} {{template.status}}
                        </div>
                    </ng-template>
                    <ng-template let-template pTemplate="selectedItem">
                        <div class="flex align-items-center gap-2" *ngIf="selectedMessageTemplate">
                            {{selectedMessageTemplate.name}} - {{selectedMessageTemplate.language}}
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-3 label">
            Free text message:
        </div>
        <div class="col-md-3">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="freeText"/>
            </div>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-3 label">
            Number to send message too:
        </div>
        <div class="col-md-3">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="destinationNumber"/>
            </div>
        </div>
    </div>


    <div class="row margin-top-16">
        <div class="col-md-3"></div>
        <div class="col-md-3" style="margin-top:auto;margin-bottom:auto;">
            <button pButton type="submit" class="p-button-raised full-width" [disabled]="busy"
                label="Send Whatsapp Message"
                (click)="sendMessage()"></button>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-3"></div>
        <div class="col-md-3" style="margin-top:auto;margin-bottom:auto;">
            <button pButton type="submit" class="p-button-raised full-width" [disabled]="busy"
                label="Sync Templates to Whatsapp"
                (click)="syncTemplates()"></button>
        </div>
    </div>


</div>